import React from 'react';
import { TextField, Switch, FormControlLabel, Button, Avatar, Grid } from '@material-ui/core';
import { Delete, Edit, Visibility } from '@mui/icons-material';
import { format } from 'date-fns';

const styles = {
    Form: {
        borderRadius: 15,
        backgroundColor: '#e6e6e6',
        color: '#314158',
        fontFamily:'montserrat',
        fontWeight: 'bold',
    }
}

function PersonData({
    informationEmployee,
    capitalizeFirstLetter
}) {
    let dataFormatada = informationEmployee.admission ? format(new Date(informationEmployee.admission), 'yyyy-MM-dd') : ''
    const formatPhone = (phone) => {
        phone = phone.replace(/\D/g, "");
        phone = phone.replace(/^(\d{2})(\d)/g,"($1) $2");
        phone = phone.replace(/(\d)(\d{4})$/,"$1-$2");
        return phone;
      };
  
    return (
        <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '4px' }}>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <TextField
                        label="Nome"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        defaultValue={capitalizeFirstLetter(informationEmployee.name)}
                        InputProps={{
                            style: styles.Form
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Cpf"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        defaultValue={capitalizeFirstLetter(informationEmployee.cpf)}
                        InputProps={{
                            style: styles.Form
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} >
                <Grid item xs={6}>
                    <TextField
                        label="Matrícula"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        defaultValue={informationEmployee.enrollment}
                        InputProps={{
                            style: styles.Form
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Cargo"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        defaultValue={capitalizeFirstLetter(informationEmployee._office)}
                        InputProps={{
                            style: styles.Form
                        }}
                    />
                </Grid>
                {/* <Grid item xs={4}>
                    <FormControlLabel control={<Switch name="status" />} label="Status" labelPlacement="start" />
                </Grid> */}
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <TextField
                        label="Data de admissão"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        defaultValue={dataFormatada}
                        InputProps={{
                            style: styles.Form
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Telefone"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        defaultValue={formatPhone(informationEmployee.phone)}
                        InputProps={{
                            style: styles.Form
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <TextField
                        label="Pis"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        defaultValue={informationEmployee.pisCode}
                        InputProps={{
                            style: styles.Form
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Telefone"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        defaultValue={informationEmployee.emailContact}
                        InputProps={{
                            style: styles.Form
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default PersonData;
